const BaseComponent = require('base/base-component');
const Server = require('helper/server');
const { districtCode } = require('helper/config');
const Config = require('helper/config');

const listTpl = Handlebars.templates['common/home/online-inquiry/templates/list-item'];

module.exports = class extends BaseComponent {
  init () {
    this.$panel = this.$el.find('.tab-panel');
    this.$tab = this.$el.find('.tab');
    this.$href = this.$el.find('.card__link');
    this.fetchData();

    this.$href.attr('href', `${Config.getZcyDomain('inquiryhall')}/inquiryhall/list?districtCode=${districtCode}`);

    this.$tab.on('click', (e) => {
      const $el = $(e.target);
      const index = $el.index();
      if (index === 0) {
        this.startScroll(0);
        this.stopScroll(1);
        this.$href.attr('href', `${Config.getZcyDomain('inquiryhall')}/inquiryhall/list?districtCode=${districtCode}`);
      } else {
        this.startScroll(1);
        this.stopScroll(0);
        this.$href.attr('href', `${Config.getZcyDomain('reversehall')}/list?districtCode=${districtCode}`);
      }
    });
  }

  fetchData () {
    let isProvince = /^\d\d0000/.test(districtCode);
    const payload = {};
    if (isProvince) {
      payload.district = /^\d{2}/.exec(districtCode)[0];
    } else {
      payload.district = /^\d{4}/.exec(districtCode)[0];
    }
    Server.getCMSData('listHall', { data: payload }).then((resp) => {
      const json = typeof resp == 'string' ? JSON.parse(resp) : resp;
      const { data } = json;
      const processedData = data.map(item =>
        $.extend({}, item, {
          tag: '询价',
          path: `${Config.getZcyDomain('inquiryhall')}/inquiryhall/detail?inquiryId=${item.id}`
        })
      );
      this.$panel.eq(0).append(listTpl({ data: processedData }));
      this.startScroll(0);
    });
    Server.getCMSData('reverseListHall', { data: { districtCode } }).then((resp) => {
      try {
        const json = typeof resp == 'string' ? JSON.parse(resp) : resp;
        const { data } = json;
        const processedData = data.map(item =>
          $.extend({}, item, { tag: '反向竞价', path: `${Config.getZcyDomain('reversehall')}/detail?id=${item.id}` })
        );
        this.$panel.eq(1).append(listTpl({ data: processedData }));
      } catch (error) {
        this.$panel.eq(1).append(listTpl({ data: [] }));
      }
    });
  }

  startScroll (index) {
    // http://www.dowebok.com/demo/188/
    const $el = this.$panel.eq(index);
    if ($el.data('moveF')) {
      $el.liMarquee('play');
    } else {
      $el.liMarquee({
        scrollamount: 30,
        direction: 'up', // 向上滚动
        runshort: false // tz内容不足不滚动
      });
    }
  }
  stopScroll (index) {
    const $el = this.$panel.eq(index);
    $el.liMarquee('pause');
  }
};
